import React, { Component } from "react";
import { Button,Form,Icon,Grid, Table } from "tabler-react";
import { GetRoles } from "../../herramientas/JWT";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
import { password } from "../../herramientas/Forms";
class  UsuarioForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nombre:      "",
      apellidos: "",
      username  : "",
      password  : "",
      Cpassword  : "",
      msmPAsss  : "",
      estatus  : false,
      newPassword  : false,
      accion: this.props.accion, //'nuevo'// modificar, nuevo
      crudbutonEnable: true, // Se desabilita cuando se hace click
                  };
    this.objeto= { "nombre": "", "apellidos": "", "username": "", "password": "" };
  }
  componentDidMount =() => {
    if(this.state.accion !== 'nuevo'){
      this.setState({nombre: this.props.elemento.nombre});
      this.setState({apellidos: this.props.elemento.apellidos});
      this.setState({username: this.props.elemento.username});
      this.setState({estatus: this.props.elemento.estatus});
      this.objeto= this.props.elemento;
    }
  }
  enableSave =() =>{
    if(
      this.state.nombre.length
      && this.state.apellidos.length
      && this.state.username.length)
      return false;
    else
      return true
  }
  changeNombre =(event) => {
    this.setState({nombre: event.target.value});
    this.objeto.nombre= event.target.value;
  }
  changeApellidos = (event) =>{
    this.setState({apellidos: event.target.value});
    this.objeto.apellidos= event.target.value;
  }
  changeUsername = (event) =>{
    this.setState({username: event.target.value});
    this.objeto.username= event.target.value;
  }
  changePassword = (event) => { 
    this.objeto.password= event.target.value;
    this.setState({ password: event.target.value });       
  }
  changeCpassword = (event) => {
    if(this.state.password !== event.target.value && this.state.password !== ""){
    }
    this.setState({ Cpassword: event.target.value });
  }
  newPassword = (event) => {
    this.setState({ newPassword: !this.state.newPassword });
    this.setState({ password: "" });
    this.setState({ Cpassword: "" });
  }

  delete() {
    this.setState({ crudbutonEnable: false });
    Crud_Catalogos(this.props.catalogo, "delete", "", this.objeto.id).then((returnVal) => {
      window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  save(metodo= "post") {
    this.setState({ crudbutonEnable: false });
    Crud_Catalogos(this.props.catalogo, metodo, this.objeto, "").then((returnVal) => {
      //window.location.reload();
    }).catch(err =>{ alert("A ocurrido un error")});
  }
  

  render(){
    return (
      <div>
        { this.state.accion === "modificar" ? <h1> { this.props.elemento.nombre } </h1> : null }
        <Grid.Row>
          <Grid.Col md={12} xl={12}>
            <Grid.Row>
              <Grid.Col md={6} lg={6}>
                <Form.Group label="Nombre">
                  <Form.Input name="nombre" type="text" value={ this.state.nombre } onChange={this.changeNombre} />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={6} lg={6}>
                <Form.Group label="Apellidos">
                  <Form.Input name="apell" type="text" value={ this.state.apellidos } onChange={this.changeApellidos} />
                </Form.Group>
              </Grid.Col>
              <Grid.Col md={6} lg={6}>
                <Form.Group label="Username">
                  <Form.Input name="username" type="text" value={ this.state.username } onChange={this.changeUsername} />
                </Form.Group>
              </Grid.Col>              
            </Grid.Row>
            {this.state.accion === "modificar"? <hr/>:null}
            <Grid.Row>
              {this.state.accion === "modificar" && !this.state.cambiarEstatus ?<h4 className="text-primary" onClick={()=> this.setState({ cambiarEstatus: !this.state.cambiarEstatus})}>Cambiar estatus</h4>:<h4></h4>}
              {this.state.accion === "modificar" && this.state.cambiarEstatus ?
                <Table.Col>
                  <Form.Group>
                    <Form.Switch name="estatus" label={this.state.estatus? "Activo": "Inactivo( El Usuario no podra iniciar sessión)"}
                      value={this.state.estatus} checked={this.state.estatus} onChange={this.changeEstatus} />
                  </Form.Group>
                  <span className="float-right ml-1">
                    <Button target="_blank" size="sm" RootComponent="a" color="danger" onClick={()=> this.setState({ cambiarEstatus: !this.state.cambiarEstatus})} >
                      <span class="badge"><Icon link={true} name="x" />Cancelar</span>
                    </Button>
                  </span>
                  <span className="float-right">
                    <Button target="_blank" size="sm" RootComponent="a" color="primary"
                      onClick={() => this.crud_put() }
                      >
                      <span class="badge"><Icon link={true} name="refresh-ccw" />Actualizar</span>
                    </Button>
                  </span>
                </Table.Col>
              : null}
            </Grid.Row>
            {this.state.accion === "modificar"? <hr/>:null}
            <Grid.Row>
              {this.state.accion === "modificar" && !this.state.newPassword?
                <Table.Col>
                  <Form.Group>
                    <h4 className="text-primary" onClick={()=> this.newPassword()}>Reestablecer contraseña</h4>
                  </Form.Group>                  
                </Table.Col>
              : null}
            </Grid.Row>
            <Grid.Row>
              { this.state.newPassword || this.state.accion !== "modificar"?
                <Grid.Col md={ 4 } lg={ 4 }>
                  <Form.Group label="password">              
                    <Form.Input name="password" type="password" disabled={ this.state.accion !== 'nuevo' && !this.state.newPassword } value={this.state.password} onChange={this.changePassword} />
                    <div className="text-danger"  >{this.state.password.length? password(this.state.password): ""}</div>
                  </Form.Group>
                </Grid.Col>
                :null}
              { this.state.newPassword?
                <Grid.Col md={ 4 } lg={ 4 }>
                  <Form.Group label="confirmar password">
                    <Form.Input name="passwordC" type="password" disabled={ this.state.accion !== 'nuevo' && !this.state.newPassword ||  password(this.state.password).length || !this.state.password.length } value={this.state.Cpassword} onChange={this.changeCpassword} />
                  </Form.Group>
                </Grid.Col>
                : null
              }
              { this.state.newPassword?
                <span className="float-right">
                  <Button target="_blank" size="sm" RootComponent="a" color="primary"
                    disabled= { this.state.Cpassword === this.state.password && this.state.password.length>0 && this.state.Cpassword.length> 0 ? false: true }
                    onClick={() => this.crud_putPassword() }
                    >
                    <span class="badge"><Icon link={true} name="refresh-ccw" />Actualizar</span>
                  </Button>
                </span>
                : null
              }
              { this.state.newPassword?
                <span className="float-right ml-1">
                  <Button target="_blank" size="sm" RootComponent="a" color="danger" onClick={()=> this.newPassword()} >
                    <span class="badge"><Icon link={true} name="x" />Cancelar</span>
                  </Button>
                </span>
              :null}
            </Grid.Row>
          </Grid.Col>
        </Grid.Row>
        <div className="float-right">
          {GetRoles().includes("root") ?
            <span class="badge">
                <Button target="_blank" size="sm" RootComponent="a" color="primary" disabled= { this.enableSave() || !this.state.crudbutonEnable }
                  onClick= { this.state.accion === "modificar" ? () => this.save("put") : () => this.save("post") }
                >
                  <span class="badge"><Icon link={true} name="save" />Guardar</span>
                </Button>
            </span>
          :null}
          { GetRoles().includes("root")  ?
            <span class="badge">
              <Button target="_blank" size="sm" RootComponent="a" color="primary"
                onClick= { () => this.delete() } disabled={!this.state.crudbutonEnable}
              >
                <span class="badge"><Icon link={true} name="trash" />Borrar</span>
              </Button>
            </span>
          :
          null
          }
        </div>
      </div>
    );
  }  
}
export default UsuarioForm;
